function styleShopPayWidget() {
  const widget = document.querySelector('shopify-payment-terms');
  if (!widget || !widget.shadowRoot) return;

  const style = document.createElement('style');
  style.textContent = `
    #shopify-installments-content, #shopify-installments-cta  {
      font-size: 13.33px !important;
      font-family: 'GT Alpina', serif !important;
      color: #000000 !important;
    }

    #shopify-installments-content .text-purple-primary {
      display: none !important;
    }

       #shopify-installments-content .text-white > svg {
      display: none !important;
    }

    [data-testid="shopify-payment-terms-modal"] button {
    font-family: 'Monument Grotesk', sans-serif !important;
    }

    #shopify-installments-cta {
    font-style: italic !important;
    }

        @font-face {
  font-family: 'GT Alpina';
  src: url('/cdn/shop/t/140/assets/font-GT-Alpina-Standard-Regular.woff2?v=179742580507908701091763122683') format('woff2'),
       url('/cdn/shop/t/140/assets/font-GT-Alpina-Standard-Regular.woff?v=14146393169284589021763122680') format('woff');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

        @font-face {
          font-family: 'Monument Grotest';
          src: url( '/cdn/shop/t/140/assets/font-ABCMonumentGrotesk-Medium.woff2?v=179587149785384590321763125929') format('woff2'),
              url('/cdn/shop/t/140/assets/font-ABCMonumentGrotesk-Medium.woff?v=86846325032767162801763125921') format('woff');
          font-weight: 500;
          font-style: normal;
          font-display: swap;
        }
  `;
  widget.shadowRoot.appendChild(style);
  const wrapper = document.querySelector('[data-shoppay-wrapper]');
  if (wrapper) wrapper.style.visibility = 'visible';
}

document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const widget = document.querySelector('shopify-payment-terms');
    if (widget?.shadowRoot?.querySelector('#shopify-installments-content')) {
      clearInterval(interval);
      styleShopPayWidget();
    }
  }, 300);
});

function modifyShopPayWidgetText() {
  const widget = document.querySelector('shopify-payment-terms');
  if (!widget || !widget.shadowRoot) return;

  const content = widget.shadowRoot.querySelector('#shopify-installments-content');
  if (!content) return;

  const textNodes = Array.from(content.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE);
  textNodes.forEach((node) => {
    if (node.textContent.includes(' with')) {
      node.textContent = node.textContent.replace(' with', '.');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const widget = document.querySelector('shopify-payment-terms');
    if (widget?.shadowRoot?.querySelector('#shopify-installments-content')) {
      clearInterval(interval);
      modifyShopPayWidgetText();
    }
  }, 300);
});

function styleShopPayModal() {
  const interval = setInterval(() => {
    const modal = document.querySelector('[data-nametag="shop-portal-provider"]');

    if (!modal) return;

    const shadow = modal.shadowRoot;

    if (!shadow) return;

    const container = shadow.querySelector('[data-testid="authorize-modal-container"]');

    if (!container) return;

    const modalSection = shadow.querySelector('section[aria-modal="true"]');
    if (modalSection) {
      modalSection.style.backgroundImage =
        "url('//dairyboy.com/cdn/shop/t/133/assets/nav-background.jpg?v=24893102273335342261759219427')";
      modalSection.style.backgroundSize = 'cover';
      modalSection.style.backgroundRepeat = 'no-repeat';
      modalSection.style.backgroundPosition = 'center';
    }

    const style = document.createElement('style');
    style.textContent = `

 footer {
      filter: brightness(0) grayscale(1) !important;
  }

          [data-testid="shopify-payment-terms-modal"] { 
      
      font-family: 'Odile', serif !important; 
      color: #000000 !important;
      }

      .text-grayscale-d0 {
       color: #000000 !important;
    }

    [data-testid="authorize-modal-header"] > svg {
        display: none !important;
      }

    [data-testid="authorize-modal-header"] .text-body-large {
    text-align: center !important;
    font-size: 19.2px !important;
    font-family: 'Sweet Sans Pro', sans-serif !important;
    text-transform: uppercase !important;
    font-weight: 400 !important;
    padding-left: 45px;
  }

  [data-testid="authorize-modal-header"] button {
  align-items: center !important;
  }

  [data-testid="shopify-payment-terms-modal"] .rounded-xs {
  border-radius: 0 !important;
  }

  [data-testid="shopify-payment-terms-modal"] button {
  background-color: #31492B !important;
  font-family: 'Monument Grotesk', sans-serif !important;
  text-transform: uppercase !important;
  color: #FFFFFF !important;
  }

  [data-testid="prequal-button-text"] {
  font-family: 'Monument Grotesk', sans-serif !important;
  text-transform: uppercase !important;
  }
  
 
    `;

    shadow.appendChild(style);
    clearInterval(interval);
  }, 500);
}

document.addEventListener('DOMContentLoaded', () => {
  styleShopPayModal();
});